import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react'

import classNames from '../../utils/classNames'

interface GlowButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode | string
  className?: string
  width?: CSSProperties['width']
  variant?: 'green' | 'blue'
}

const GlowButton = ({
  children,
  className = '',
  width,
  style = {},
  variant = 'green',
  ...rest
}: GlowButtonProps) => {
  return (
    <button
      className={classNames(
        'flx-ctr text-white font-bold uppercase rounded-md transition-all dark:font-extrabold dark:tracking-[0.02em] disabled:opacity-50 disabled:pointer-events-none',
        variant === 'green' && 'deposit-submit-btn bg-highlight',
        variant === 'blue' && 'glow-btn-blue',
        className,
      )}
      style={{ width, ...style }}
      {...rest}>
      {children}
    </button>
  )
}

export default GlowButton
